
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jzTw0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7dd4c1d76ada102c$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $7dd4c1d76ada102c$export$2e2bcd8739ae039 = {
    'fabric.linking.accounts': "\xda\u010Dty",
    'fabric.linking.actions': 'Akcie',
    'fabric.linking.add_account': "Prida\u0165 \xfa\u010Det",
    'fabric.linking.annotate': "Komentova\u0165",
    'fabric.linking.annotate.confirmation.close.anyway': "Aj tak zatvori\u0165",
    'fabric.linking.annotate.confirmation.content': "M\xe1te neulo\u017Een\xe9 zmeny. Naozaj chcete od\xeds\u0165?",
    'fabric.linking.annotate.confirmation.heading': "Neulo\u017Een\xe9 zmeny",
    'fabric.linking.annotate.tool.arrow': "\u0160\xedpka",
    'fabric.linking.annotate.tool.blur': 'Rozmazanie',
    'fabric.linking.annotate.tool.brush': "\u0160tetec",
    'fabric.linking.annotate.tool.color': 'Farba',
    'fabric.linking.annotate.tool.line.thickness': "Hr\xfabka \u010Diary",
    'fabric.linking.annotate.tool.shape': 'Tvar',
    'fabric.linking.annotate.tool.text': 'Text',
    'fabric.linking.audio': 'zvuk',
    'fabric.linking.cancel': "Zru\u0161i\u0165",
    'fabric.linking.cant_preview_file_type': "Nem\xf4\u017Eeme zobrazi\u0165 n\xe1h\u013Ead tohto typu s\xfaboru.",
    'fabric.linking.cant_retrieve_files': "Ejha! Nepodarilo sa n\xe1m na\u010D\xedta\u0165 \u017Eiadne s\xfabory.",
    'fabric.linking.cant_retrieve_gifs': "Ach nie! Nepodarilo sa n\xe1m z\xedska\u0165 \u017Eiadne obr\xe1zky GIF",
    'fabric.linking.check_your_network': "Skontrolujte sie\u0165ov\xe9 pripojenie",
    'fabric.linking.close': "Zatvori\u0165",
    'fabric.linking.connect_account_description': "Otvor\xedme nov\xfa str\xe1nku, aby sme v\xe1m pomohli pri pripojen\xed k v\xe1\u0161mu \xfa\u010Dtu {name}",
    'fabric.linking.connect_link_account': "Ak chcete zobrazi\u0165 n\xe1h\u013Ead, pripojte svoj \xfa\u010Det",
    'fabric.linking.connect_link_account_card_view': "Pripoji\u0165",
    'fabric.linking.connect_link_account_card_view_name': "Pripojte svoj \xfa\u010Det {context}",
    'fabric.linking.connect_to': "Pripoji\u0165 k {name}",
    'fabric.linking.could_not_load_editor': "\u013Dutujeme, nepodarilo sa na\u010D\xedta\u0165 editor",
    'fabric.linking.could_not_save_image': "\u013Dutujeme, nepodarilo sa ulo\u017Ei\u0165 obr\xe1zok",
    'fabric.linking.couldnt_generate_preview': "Nepodarilo sa vytvori\u0165 n\xe1h\u013Ead tohto s\xfaboru.",
    'fabric.linking.default_avatars': "Predvolen\xe9 avatary",
    'fabric.linking.disable_fullscreen': "deaktivova\u0165 zobrazenie na cel\xfa obrazovku",
    'fabric.linking.document': 'dokument',
    'fabric.linking.download': "Prevzia\u0165",
    'fabric.linking.drag_and_drop_images_here': "Sem my\u0161ou presu\u0148te obr\xe1zky",
    'fabric.linking.drag_and_drop_your_files': "Kdeko\u013Evek potiahnite a pustite s\xfabory alebo",
    'fabric.linking.drop_your_files': "Pustite s\xfabory na nahranie",
    'fabric.linking.drop_your_files_here': "Sem presu\u0148te s\xfabory",
    'fabric.linking.enable_fullscreen': "povoli\u0165 zobrazenie na cel\xfa obrazovku",
    'fabric.linking.error_generating_preview': "Pri vytv\xe1ran\xed n\xe1h\u013Eadu sa vyskytla chyba",
    'fabric.linking.error_hint_critical': "Ak probl\xe9m pretrv\xe1va, obr\xe1\u0165te sa na podporu.",
    'fabric.linking.error_hint_retry': "Sk\xfaste to znova a my tomu d\xe1me druh\xfa \u0161ancu.",
    'fabric.linking.error_loading_file': "Pri na\u010D\xedtan\xed s\xfaboru sa vyskytla chyba",
    'fabric.linking.failed_to_load': 'Nahratie zlyhalo',
    'fabric.linking.give_feedback': "Poskytn\xfa\u0165 sp\xe4tn\xfa v\xe4zbu",
    'fabric.linking.image': "obr\xe1zok",
    'fabric.linking.image_format_invalid_error': "Nepodarilo sa na\u010D\xedta\u0165 obr\xe1zok, form\xe1t je neplatn\xfd.",
    'fabric.linking.image_size_too_large_error': "Obr\xe1zok je pr\xedli\u0161 ve\u013Ek\xfd, nesmie by\u0165 v\xe4\u010D\u0161\xed ako {MAX_SIZE_MB} Mb",
    'fabric.linking.image_url_invalid_error': "Nepodarilo sa na\u010D\xedta\u0165 obr\xe1zok, adresa url je neplatn\xe1.",
    'fabric.linking.insert_files': "{0, plural, one {Vlo\u017Ei\u0165 {0} s\xfabor} few {Vlo\u017Ei\u0165 {0} s\xfabory} many {Vlo\u017Ei\u0165 {0} s\xfaboru} other {Vlo\u017Ei\u0165 {0} s\xfaborov}}",
    'fabric.linking.invalid_permissions_description': "Ak si chcete zobrazi\u0165 tento n\xe1h\u013Ead, po\u017Eiadajte o pr\xedstup alebo vysk\xfa\u0161ajte in\xfd \xfa\u010Det.",
    'fabric.linking.item_not_found_in_list': "Vybran\xe1 polo\u017Eka sa nena\u0161la v zozname.",
    'fabric.linking.learn_more': "\u010Eal\u0161ie inform\xe1cie",
    'fabric.linking.load_more_gifs': "Na\u010D\xedta\u0165 viac obr\xe1zkov GIF",
    'fabric.linking.loading': "Na\u010D\xedtava sa...",
    'fabric.linking.might_be_a_hiccup': "M\xf4\u017Ee to by\u0165 len nejak\xfd nepodstatn\xfd probl\xe9m.",
    'fabric.linking.no_gifs_found': "Dobr\xfd de\u0148? Poviete n\xe1m, \u010Do h\u013Ead\xe1te?",
    'fabric.linking.no_gifs_found_suggestion': 'Ni\u010D sa n\xe1m nepodarilo n\xe1js\u0165 pre "{query}"',
    'fabric.linking.no_pdf_artifacts': "Pre tento s\xfabor sa nena\u0161li \u017Eiadne \u010Dasti PDF.",
    'fabric.linking.not_found_title': "Ejha. Toto prepojenie sa nepodarilo n\xe1js\u0165.",
    'fabric.linking.or': 'alebo',
    'fabric.linking.recent_uploads': "Posledn\xe9 nahrania",
    'fabric.linking.remove_image': "Odstr\xe1ni\u0165 obr\xe1zok",
    'fabric.linking.retry': "Opakova\u0165",
    'fabric.linking.save': "Ulo\u017Ei\u0165",
    'fabric.linking.search_all_gifs': "Preh\u013Eada\u0165 v\u0161etky obr\xe1zky GIF!",
    'fabric.linking.share_files_instantly': "Okam\u017Eite ich za\u010Dneme zdie\u013Ea\u0165",
    'fabric.linking.something_went_wrong': "Vyskytol sa probl\xe9m.",
    'fabric.linking.srclink': "Zobrazi\u0165 v:",
    'fabric.linking.srclinkunknown': "Zobrazi\u0165 origin\xe1l",
    'fabric.linking.try_again': "Sk\xfaste to znova",
    'fabric.linking.try_another_account': "Vysk\xfa\u0161ajte in\xfd \xfa\u010Det",
    'fabric.linking.try_downloading_file': "Sk\xfaste prevzia\u0165 tento s\xfabor na jeho zobrazenie.",
    'fabric.linking.unable_to_annotate_image': "Nem\xf4\u017Eete komentova\u0165 tento obr\xe1zok",
    'fabric.linking.unknown': "nezn\xe1me",
    'fabric.linking.unlink_account': "Zru\u0161i\u0165 prepojenie \xfa\u010Dtu",
    'fabric.linking.upload': "Nahra\u0165",
    'fabric.linking.upload_an_avatar': "Nahra\u0165 avatara",
    'fabric.linking.upload_file': "Nahra\u0165 s\xfabor",
    'fabric.linking.upload_file_from': "Nahra\u0165 s\xfabor z {name}",
    'fabric.linking.upload_image': "Nahra\u0165  obr\xe1zok",
    'fabric.linking.upload_photo': "Nahra\u0165 fotografiu",
    'fabric.linking.video': 'video',
    'fabric.linking.webgl_warning_description': "V\xe1\u0161 prehliada\u010D nepodporuje kni\u017Enicu WebGL. Ak chcete komentova\u0165 obr\xe1zky, pou\u017Eite prehliada\u010D s povolenou kni\u017Enicou WebGL.",
    'fabric.linking.zoom_in': "pribl\xed\u017Ei\u0165",
    'fabric.linking.zoom_out': "oddiali\u0165"
};

});


//# sourceMappingURL=sk.9fc34304.js.map
